var map = {
	"./18C.png": 610,
	"./BITCOIN.png": 753,
	"./BITCOINLARGER.png": 21,
	"./BUSD-lg.png": 109,
	"./BUSD.png": 702,
	"./ETHERIUM-lg.png": 729,
	"./ETHERIUM.png": 518,
	"./EUR-lg.png": 762,
	"./EUR.png": 111,
	"./GBP.png": 559,
	"./INCH-lg.png": 821,
	"./INCH.png": 392,
	"./OX-larger.png": 233,
	"./OX.png": 835,
	"./SHIB-lg.png": 152,
	"./SHIB.png": 410,
	"./TETHERUS-lg.png": 550,
	"./TETHERUS.png": 306,
	"./USD-lg.png": 275,
	"./USD.png": 180,
	"./XEC-lg.png": 700,
	"./XEC.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;